/** Demo images stay in this browser. Synthetic HTTPS references keep saved
 * documents schema-compatible; previews resolve them without network calls. */
const prefix = "https://demo.trykate.invalid/media/";
export function demoMediaSource(url: string) {
  if (!url.startsWith(prefix)) return url;
  return localStorage.getItem(`kate-demo-media-${url.slice(prefix.length)}`) || "";
}
export async function saveDemoMedia(file: File) {
  const bitmap = await createImageBitmap(file);
  try {
    const canvas = document.createElement("canvas");
    const scale = Math.min(1, 512 / Math.max(bitmap.width, bitmap.height));
    canvas.width = Math.max(1, Math.round(bitmap.width * scale)); canvas.height = Math.max(1, Math.round(bitmap.height * scale));
    const context = canvas.getContext("2d"); if (!context) throw new Error("Image preview is unavailable");
    context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    const encoded = canvas.toDataURL("image/webp", 0.65);
    if (encoded.length > 120_000) throw new Error("Use a smaller image for the local demo.");
    const id = crypto.randomUUID();
    localStorage.setItem(`kate-demo-media-${id}`, encoded);
    return { id, url: `${prefix}${id}` };
  } finally { bitmap.close(); }
}
